<navaar-container-scroll
    class="list-categories"
    [showHeader]="true"
    [title]="'بایگانی'"
    [show]="true"
    [isPlayAnimation]="false"
    [showIcon]="true"
    [isFixedContainer]="true"
    [back-url]="['/profile']"
>
    <section class="book-profile-section book-about-us-content">
        <div class="container">
            <div class="wishlist-main-container archive-page">
                <section class="container-tabs">
                    <ul>
                        <li
                            [class.active]="_showTab[0]"
                            (click)="showTab(0)"
                        >
                            <p
                                class="tab-item"
                                data-badge="4"
                            >
                                <span>
                                    <span
                                        class="count-badge"
                                        *ngIf="dataBadge[0]"
                                        [textContent]="dataBadge[0]"
                                    ></span>
                                    کتاب صوتی
                                </span>
                            </p>
                        </li>
                        <li
                            [class.active]="_showTab[1]"
                            (click)="showTab(1)"
                        >
                            <p class="tab-item">
                                <span>
                                    <span
                                        class="count-badge"
                                        *ngIf="dataBadge[1]"
                                        [textContent]="dataBadge[1]"
                                    ></span>
                                    کپسول
                                </span>






                            </p>
                        </li>
                        <li
                            [class.active]="_showTab[2]"
                            (click)="showTab(2)"
                        >
                            <p class="tab-item">
                                <span>
                                    <span
                                        class="count-badge"
                                        *ngIf="dataBadge[2]"
                                        [textContent]="dataBadge[2]"
                                    ></span>
                                    سریال صوتی
                                </span>
                            </p>
                        </li>
                        <li
                            [class.active]="_showTab[3]"
                            (click)="showTab(3)"
                        >
                            <p class="tab-item">
                                <span>
                                    <span
                                        class="count-badge"
                                        *ngIf="dataBadge[3]"
                                        [textContent]="dataBadge[3]"
                                    ></span>
                                    پادکست
                                </span>
                            </p>
                        </li>
                    </ul>
                </section>
                <section
                    class="book-search-section book-search-form"
                    [class.ios-search]="device.isIOS()"
                >
                    <div class="wrapper-filter-input">
                        <input
                            #term
                            (input)="filterChange(term.value)"
                            type="text"
                            class="search-field"
                            name="search-field"
                            placeholder="فیلتر"
                            [value]="searchText"
                        >
                        <i
                            *ngIf="searchText?.length > 0"
                            (click)="filterChange('')"
                        >
                            <navaar-close-icon [style]="{width: '20px', height: '20px'}"></navaar-close-icon>
                        </i>
                    </div>
                </section>
                <section
                    class="book-search-section book-search-form"
                    *ngIf="appVersionNotSupport"
                >
                    <div class="container">
                        <div class="default-box alert-text">
                            <br>
                            جهت استفاده از این قابلیت
                            <br>
                            اپلیکیشن خود را به آخرین نسخه بروزرسانی کنید
                            <br>
                            <br>
                        </div>
                    </div>
                </section>
                <section class="container-tabs tabs-content">
                    <div
                        [hidden]="!_showTab[0]"
                        class="list-container"
                        *ngIf="!appVersionNotSupport"
                    >
                        <div
                            *ngFor="let book of FilteredItems[0]"
                            class="categories-item"
                            (click)="goToBook(book.audioBook.identifier)"
                        >
                            <ng-container *ngTemplateOutlet="option_menu;context:{ $implicit: book }"></ng-container>
                            <div class="cur-categories-txt truncate">
                                <ng-container *ngTemplateOutlet="audiobook_icon"></ng-container>
                                <span
                                    class="cur-categories-name"
                                    [textContent]="book.audioBook.title"
                                ></span>
                                <div class="center-row-container">
                                    <span class="purchase-container no-padding"></span>






                                    <span
                                        class="cur-categories-author no-padding"
                                        [textContent]="book.audioBook.authors | CombineMultipleAuthorsName"
                                    >
                                    </span>






                                </div>
                                <!-- rate container -->
                                <div class="rate-container">
                                    <div
                                        *ngIf="book.audioBook.rating"
                                        class="cur-categories-rating"
                                    >
                                        <div class="star-list">
                                            <div *ngFor="let rating of maxRatingCount">
                                                <div [ngSwitch]="book.audioBook.rating.average >= rating">
                                                    <div *ngSwitchCase="true">
                                                        <!-- full star -->
                                                        <svg
                                                            id="fullStar"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            :xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            x="0px"
                                                            y="0px"
                                                            width="10px"
                                                            height="10px"
                                                            viewBox="0 0 15 15"
                                                            enable-background="new 0 0 15 15"
                                                            :xml:space="preserve"
                                                        >
                                                            <path
                                                                fill="#0085CB"
                                                                stroke="#0085CB"
                                                                stroke-miterlimit="10"
                                                                d="M7.478,1.038L9.8,4.993l4.3,1.079l-2.882,3.506l0.344,4.585
                              L7.478,12.41l-4.041,1.753l0.344-4.585L0.9,6.072l4.3-1.079L7.478,1.038z"
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                    <div *ngSwitchCase="false">
                                                        <div [ngSwitch]="book.audioBook.rating.average > (rating-1)">
                                                            <div *ngSwitchCase="true">
                                                                <!-- under half -->
                                                                <div *ngIf="( book.audioBook.rating.average - (book.audioBook.rating.average | Trunc)) < 0.5">
                                                                    <svg
                                                                        id="underHlfStart"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        :xmlns:xlink="http://www.w3.org/1999/xlink"
                                                                        x="0px"
                                                                        y="0px"
                                                                        width="10px"
                                                                        height="10px"
                                                                        viewBox="0 0 15 15"
                                                                        enable-background="new 0 0 15 15"
                                                                        :xml:space="preserve"
                                                                    >
                                                                        <path
                                                                            fill="#0085CB"
                                                                            d="M5.583,13.75l-2.662,1.192l0.39-5.195L0.047,5.775l5.492-1.371L5.583,13.75z"
                                                                        ></path>
                                                                        <path
                                                                            fill="none"
                                                                            stroke="#0085CB"
                                                                            stroke-miterlimit="10"
                                                                            d="M7.478,1.038L9.8,4.993l4.3,1.079l-2.882,3.506l0.344,4.585
                                  L7.478,12.41l-4.041,1.753l0.344-4.585L0.9,6.072l4.3-1.079L7.478,1.038z"
                                                                        ></path>
                                                                    </svg>
                                                                </div>
                                                                <!-- half star -->
                                                                <div *ngIf="( book.audioBook.rating.average - (book.audioBook.rating.average | Trunc)) == 0.5">
                                                                    <svg
                                                                        id="halfStar"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        :xmlns:xlink="http://www.w3.org/1999/xlink"
                                                                        x="0px"
                                                                        y="0px"
                                                                        width="10px"
                                                                        height="10px"
                                                                        viewBox="0 0 15 15"
                                                                        enable-background="new 0 0 15 15"
                                                                        :xml:space="preserve"
                                                                    >
                                                                        <path
                                                                            fill="#0085CB"
                                                                            d="M7.5,0.07v12.886l-4.579,1.986l0.39-5.195L0.047,5.775l4.872-1.222L7.5,0.07z"
                                                                        ></path>
                                                                        <path
                                                                            fill="none"
                                                                            stroke="#0085CB"
                                                                            stroke-miterlimit="10"
                                                                            d="M7.478,1.038L9.8,4.993l4.3,1.079l-2.882,3.506l0.344,4.585
                                    L7.478,12.41l-4.041,1.753l0.344-4.585L0.9,6.072l4.3-1.079L7.478,1.038z"
                                                                        ></path>
                                                                    </svg>
                                                                </div>
                                                                <!-- upper half -->
                                                                <div *ngIf="( book.audioBook.rating.average - (book.audioBook.rating.average | Trunc)) > 0.5">
                                                                    <svg
                                                                        id="upperHalfStar"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        :xmlns:xlink="http://www.w3.org/1999/xlink"
                                                                        x="0px"
                                                                        y="0px"
                                                                        width="10px"
                                                                        height="10px"
                                                                        viewBox="0 0 15 15"
                                                                        enable-background="new 0 0 15 15"
                                                                        :xml:space="preserve"
                                                                    >
                                                                        <path
                                                                            fill="#0085CB"
                                                                            d="M7.467,0.1l2.285,3.895L9.553,13.82l-2.086-0.896L2.915,14.9l0.388-5.17L0.057,5.777l4.843-1.217L7.467,0.1z
                                    "
                                                                        ></path>
                                                                        <path
                                                                            fill="none"
                                                                            stroke="#0085CB"
                                                                            stroke-miterlimit="10"
                                                                            d="M7.478,1.038L9.8,4.993l4.3,1.079l-2.882,3.506l0.344,4.585
                                    L7.478,12.41l-4.041,1.753l0.344-4.585L0.9,6.072l4.3-1.079L7.478,1.038z"
                                                                        ></path>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                            <!-- empty start -->
                                                            <div *ngSwitchCase="false">
                                                                <svg
                                                                    id="Layer_1"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    :xmlns:xlink="http://www.w3.org/1999/xlink"
                                                                    x="0px"
                                                                    y="0px"
                                                                    width="10px"
                                                                    height="10px"
                                                                    viewBox="0 0 15 15"
                                                                    enable-background="new 0 0 15 15"
                                                                    :xml:space="preserve"
                                                                >
                                                                    <path
                                                                        fill="none"
                                                                        stroke="#0085CB"
                                                                        stroke-miterlimit="10"
                                                                        d="M7.478,1.038L9.8,4.993l4.3,1.079l-2.882,3.506l0.344,4.585
                              L7.478,12.41l-4.041,1.753l0.344-4.585L0.9,6.072l4.3-1.079L7.478,1.038z"
                                                                    ></path>
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="cur-categories-img">
                                <img
                                    [lazySrc]="_environment.imageUrl + '/content/books/' + book.audioBook.audioBookId + '/pic.jpg?t=' + book.audioBook.recordVersion + '&w=250&h=250&mode=stretch'"
                                    lazySrcVisible="visible"
                                    loading="lazy"
                                    src="assets/img/placeholder.png"
                                    class="wrapper-img-slider"
                                >
                            </div>
                        </div>
                    </div>
                    <div
                        [hidden]="!_showTab[1]"
                        class="list-container"
                    >
                        <div
                            *ngFor="let book of FilteredItems[1]"
                            class="categories-item"
                            (click)="goToBook(book.audioBook.identifier)"
                        >
                        <ng-container *ngTemplateOutlet="option_menu;context:{ $implicit: book }"></ng-container>
                            <div class="cur-categories-txt truncate">
                                <!-- capsul icon -->
                                <ng-container *ngTemplateOutlet="capsul_icon"></ng-container>
                                <span
                                    class="cur-categories-name"
                                    [textContent]="book.audioBook.title"
                                ></span>
                                <div class="center-row-container">
                                    <span class="purchase-container no-padding"></span>
                                    <span
                                        class="cur-categories-author no-padding"
                                        [textContent]="book.audioBook.authors  | CombineMultipleAuthorsName"
                                    >
                                    </span>
                                </div>
                                <!-- rate container -->
                                <div class="rate-container">
                                    <div
                                        *ngIf="book.audioBook.rating"
                                        class="cur-categories-rating"
                                    >
                                        <div class="star-list">
                                            <div *ngFor="let rating of maxRatingCount">
                                                <div [ngSwitch]="book.audioBook.rating.average >= rating">
                                                    <div *ngSwitchCase="true">
                                                        <!-- full star -->
                                                        <svg
                                                            id="fullStar"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            :xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            x="0px"
                                                            y="0px"
                                                            width="10px"
                                                            height="10px"
                                                            viewBox="0 0 15 15"
                                                            enable-background="new 0 0 15 15"
                                                            :xml:space="preserve"
                                                        >
                                                            <path
                                                                fill="#0085CB"
                                                                stroke="#0085CB"
                                                                stroke-miterlimit="10"
                                                                d="M7.478,1.038L9.8,4.993l4.3,1.079l-2.882,3.506l0.344,4.585
                              L7.478,12.41l-4.041,1.753l0.344-4.585L0.9,6.072l4.3-1.079L7.478,1.038z"
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                    <div *ngSwitchCase="false">
                                                        <div [ngSwitch]="book.audioBook.rating.average > (rating-1)">
                                                            <div *ngSwitchCase="true">
                                                                <!-- under half -->
                                                                <div *ngIf="( book.audioBook.rating.average - (book.audioBook.rating.average | Trunc)) < 0.5">
                                                                    <svg
                                                                        id="underHlfStart"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        :xmlns:xlink="http://www.w3.org/1999/xlink"
                                                                        x="0px"
                                                                        y="0px"
                                                                        width="10px"
                                                                        height="10px"
                                                                        viewBox="0 0 15 15"
                                                                        enable-background="new 0 0 15 15"
                                                                        :xml:space="preserve"
                                                                    >
                                                                        <path
                                                                            fill="#0085CB"
                                                                            d="M5.583,13.75l-2.662,1.192l0.39-5.195L0.047,5.775l5.492-1.371L5.583,13.75z"
                                                                        ></path>
                                                                        <path
                                                                            fill="none"
                                                                            stroke="#0085CB"
                                                                            stroke-miterlimit="10"
                                                                            d="M7.478,1.038L9.8,4.993l4.3,1.079l-2.882,3.506l0.344,4.585
                                  L7.478,12.41l-4.041,1.753l0.344-4.585L0.9,6.072l4.3-1.079L7.478,1.038z"
                                                                        ></path>
                                                                    </svg>
                                                                </div>
                                                                <!-- half star -->
                                                                <div *ngIf="( book.audioBook.rating.average - (book.audioBook.rating.average | Trunc)) == 0.5">
                                                                    <svg
                                                                        id="halfStar"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        :xmlns:xlink="http://www.w3.org/1999/xlink"
                                                                        x="0px"
                                                                        y="0px"
                                                                        width="10px"
                                                                        height="10px"
                                                                        viewBox="0 0 15 15"
                                                                        enable-background="new 0 0 15 15"
                                                                        :xml:space="preserve"
                                                                    >
                                                                        <path
                                                                            fill="#0085CB"
                                                                            d="M7.5,0.07v12.886l-4.579,1.986l0.39-5.195L0.047,5.775l4.872-1.222L7.5,0.07z"
                                                                        ></path>
                                                                        <path
                                                                            fill="none"
                                                                            stroke="#0085CB"
                                                                            stroke-miterlimit="10"
                                                                            d="M7.478,1.038L9.8,4.993l4.3,1.079l-2.882,3.506l0.344,4.585
                                    L7.478,12.41l-4.041,1.753l0.344-4.585L0.9,6.072l4.3-1.079L7.478,1.038z"
                                                                        ></path>
                                                                    </svg>
                                                                </div>
                                                                <!-- upper half -->
                                                                <div *ngIf="( book.audioBook.rating.average - (book.audioBook.rating.average | Trunc)) > 0.5">
                                                                    <svg
                                                                        id="upperHalfStar"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        :xmlns:xlink="http://www.w3.org/1999/xlink"
                                                                        x="0px"
                                                                        y="0px"
                                                                        width="10px"
                                                                        height="10px"
                                                                        viewBox="0 0 15 15"
                                                                        enable-background="new 0 0 15 15"
                                                                        :xml:space="preserve"
                                                                    >
                                                                        <path
                                                                            fill="#0085CB"
                                                                            d="M7.467,0.1l2.285,3.895L9.553,13.82l-2.086-0.896L2.915,14.9l0.388-5.17L0.057,5.777l4.843-1.217L7.467,0.1z
                                    "
                                                                        ></path>
                                                                        <path
                                                                            fill="none"
                                                                            stroke="#0085CB"
                                                                            stroke-miterlimit="10"
                                                                            d="M7.478,1.038L9.8,4.993l4.3,1.079l-2.882,3.506l0.344,4.585
                                    L7.478,12.41l-4.041,1.753l0.344-4.585L0.9,6.072l4.3-1.079L7.478,1.038z"
                                                                        ></path>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                            <!-- empty start -->
                                                            <div *ngSwitchCase="false">
                                                                <svg
                                                                    id="Layer_1"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    :xmlns:xlink="http://www.w3.org/1999/xlink"
                                                                    x="0px"
                                                                    y="0px"
                                                                    width="10px"
                                                                    height="10px"
                                                                    viewBox="0 0 15 15"
                                                                    enable-background="new 0 0 15 15"
                                                                    :xml:space="preserve"
                                                                >
                                                                    <path
                                                                        fill="none"
                                                                        stroke="#0085CB"
                                                                        stroke-miterlimit="10"
                                                                        d="M7.478,1.038L9.8,4.993l4.3,1.079l-2.882,3.506l0.344,4.585
                              L7.478,12.41l-4.041,1.753l0.344-4.585L0.9,6.072l4.3-1.079L7.478,1.038z"
                                                                    ></path>
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="cur-categories-img">
                                <img
                                    [lazySrc]="_environment.imageUrl + '/content/books/' + book.audioBook.audioBookId + '/pic.jpg?t=' + book.audioBook.recordVersion + '&w=250&h=250&mode=stretch'"
                                    lazySrcVisible="visible"
                                    loading="lazy"
                                    src="assets/img/placeholder.png"
                                    class="wrapper-img-slider"
                                >
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="_showTab[2]"
                        class="list-container"
                    >
                        <div
                            *ngFor="let book of FilteredItems[2]"
                            class="categories-item"
                            (click)="goToBook(book.audioBook.identifier)"
                        >
                            <ng-container *ngTemplateOutlet="option_menu;context:{ $implicit: book }"></ng-container>
                            <div class="cur-categories-txt truncate">
                                <!-- series icon -->
                                <ng-container *ngTemplateOutlet="series_icon"></ng-container>
                                <span
                                    class="cur-categories-name"
                                    [textContent]="book.audioBook.title"
                                ></span>
                                <div class="center-row-container">
                                    <span class="purchase-container no-padding"></span>
                                    <span
                                        class="cur-categories-author no-padding"
                                        [textContent]="book.audioBook.authors  | CombineMultipleAuthorsName"
                                    >
                                    </span>
                                </div>
                                <!-- rate container -->
                                <div class="rate-container">
                                    <div
                                        *ngIf="book.audioBook.rating"
                                        class="cur-categories-rating"
                                    >
                                        <div class="star-list">






                                            <div *ngFor="let rating of maxRatingCount">
                                                <div [ngSwitch]="book.audioBook.rating.average >= rating">
                                                    <div *ngSwitchCase="true">
                                                        <!-- full star -->
                                                        <svg
                                                            id="fullStar"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            :xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            x="0px"
                                                            y="0px"
                                                            width="10px"
                                                            height="10px"
                                                            viewBox="0 0 15 15"
                                                            enable-background="new 0 0 15 15"
                                                            :xml:space="preserve"
                                                        >
                                                            <path
                                                                fill="#0085CB"
                                                                stroke="#0085CB"
                                                                stroke-miterlimit="10"
                                                                d="M7.478,1.038L9.8,4.993l4.3,1.079l-2.882,3.506l0.344,4.585
                              L7.478,12.41l-4.041,1.753l0.344-4.585L0.9,6.072l4.3-1.079L7.478,1.038z"
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                    <div *ngSwitchCase="false">
                                                        <div [ngSwitch]="book.audioBook.rating.average > (rating-1)">
                                                            <div *ngSwitchCase="true">






                                                                <!-- under half -->
                                                                <div *ngIf="( book.audioBook.rating.average - (book.audioBook.rating.average | Trunc)) < 0.5">
                                                                    <svg
                                                                        id="underHlfStart"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        :xmlns:xlink="http://www.w3.org/1999/xlink"
                                                                        x="0px"
                                                                        y="0px"
                                                                        width="10px"
                                                                        height="10px"
                                                                        viewBox="0 0 15 15"
                                                                        enable-background="new 0 0 15 15"
                                                                        :xml:space="preserve"
                                                                    >
                                                                        <path
                                                                            fill="#0085CB"
                                                                            d="M5.583,13.75l-2.662,1.192l0.39-5.195L0.047,5.775l5.492-1.371L5.583,13.75z"
                                                                        ></path>
                                                                        <path
                                                                            fill="none"
                                                                            stroke="#0085CB"
                                                                            stroke-miterlimit="10"
                                                                            d="M7.478,1.038L9.8,4.993l4.3,1.079l-2.882,3.506l0.344,4.585
                                  L7.478,12.41l-4.041,1.753l0.344-4.585L0.9,6.072l4.3-1.079L7.478,1.038z"
                                                                        ></path>
                                                                    </svg>
                                                                </div>






                                                                <!-- half star -->
                                                                <div *ngIf="( book.audioBook.rating.average - (book.audioBook.rating.average | Trunc)) == 0.5">
                                                                    <svg
                                                                        id="halfStar"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        :xmlns:xlink="http://www.w3.org/1999/xlink"
                                                                        x="0px"
                                                                        y="0px"
                                                                        width="10px"
                                                                        height="10px"
                                                                        viewBox="0 0 15 15"
                                                                        enable-background="new 0 0 15 15"
                                                                        :xml:space="preserve"
                                                                    >
                                                                        <path
                                                                            fill="#0085CB"
                                                                            d="M7.5,0.07v12.886l-4.579,1.986l0.39-5.195L0.047,5.775l4.872-1.222L7.5,0.07z"
                                                                        ></path>
                                                                        <path
                                                                            fill="none"
                                                                            stroke="#0085CB"
                                                                            stroke-miterlimit="10"
                                                                            d="M7.478,1.038L9.8,4.993l4.3,1.079l-2.882,3.506l0.344,4.585
                                    L7.478,12.41l-4.041,1.753l0.344-4.585L0.9,6.072l4.3-1.079L7.478,1.038z"
                                                                        ></path>
                                                                    </svg>
                                                                </div>






                                                                <!-- upper half -->
                                                                <div *ngIf="( book.audioBook.rating.average - (book.audioBook.rating.average | Trunc)) > 0.5">
                                                                    <svg
                                                                        id="upperHalfStar"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        :xmlns:xlink="http://www.w3.org/1999/xlink"
                                                                        x="0px"
                                                                        y="0px"
                                                                        width="10px"
                                                                        height="10px"
                                                                        viewBox="0 0 15 15"
                                                                        enable-background="new 0 0 15 15"
                                                                        :xml:space="preserve"
                                                                    >
                                                                        <path
                                                                            fill="#0085CB"
                                                                            d="M7.467,0.1l2.285,3.895L9.553,13.82l-2.086-0.896L2.915,14.9l0.388-5.17L0.057,5.777l4.843-1.217L7.467,0.1z
                                    "
                                                                        ></path>
                                                                        <path
                                                                            fill="none"
                                                                            stroke="#0085CB"
                                                                            stroke-miterlimit="10"
                                                                            d="M7.478,1.038L9.8,4.993l4.3,1.079l-2.882,3.506l0.344,4.585
                                    L7.478,12.41l-4.041,1.753l0.344-4.585L0.9,6.072l4.3-1.079L7.478,1.038z"
                                                                        ></path>
                                                                    </svg>
                                                                </div>
                                                            </div>






                                                            <!-- empty start -->
                                                            <div *ngSwitchCase="false">
                                                                <svg
                                                                    id="Layer_1"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    :xmlns:xlink="http://www.w3.org/1999/xlink"
                                                                    x="0px"
                                                                    y="0px"
                                                                    width="10px"
                                                                    height="10px"
                                                                    viewBox="0 0 15 15"
                                                                    enable-background="new 0 0 15 15"
                                                                    :xml:space="preserve"
                                                                >
                                                                    <path
                                                                        fill="none"
                                                                        stroke="#0085CB"
                                                                        stroke-miterlimit="10"
                                                                        d="M7.478,1.038L9.8,4.993l4.3,1.079l-2.882,3.506l0.344,4.585
                              L7.478,12.41l-4.041,1.753l0.344-4.585L0.9,6.072l4.3-1.079L7.478,1.038z"
                                                                    ></path>
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>






                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="cur-categories-img">
                                <img
                                    [lazySrc]="_environment.imageUrl + '/content/books/' + book.audioBook.audioBookId + '/pic.jpg?t=' + book.audioBook.recordVersion + '&w=250&h=250&mode=stretch'"
                                    lazySrcVisible="visible"
                                    loading="lazy"
                                    src="assets/img/placeholder.png"
                                    class="wrapper-img-slider"
                                >
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="_showTab[3]"
                        class="list-container"
                    >
                        <div
                            *ngFor="let book of FilteredItems[3]"
                            class="categories-item"
                            (click)="goToBook(book.audioBook.identifier)"
                        >
                            <ng-container *ngTemplateOutlet="option_menu;context:{ $implicit: book }"></ng-container>
                            <div class="cur-categories-txt truncate">
                                <!-- podcast icon -->
                                <ng-container *ngTemplateOutlet="podcast_icon"></ng-container>
                                <span
                                    class="cur-categories-name"
                                    [textContent]="book.audioBook.title"
                                ></span>
                                <div class="center-row-container">
                                    <span class="purchase-container no-padding"></span>
                                    <span
                                        class="cur-categories-author no-padding"
                                        [textContent]="book.audioBook.authors  | CombineMultipleAuthorsName"
                                    >
                                    </span>
                                </div>
                                <!-- rate container -->
                                <div class="rate-container">
                                    <div
                                        *ngIf="book.audioBook.rating"
                                        class="cur-categories-rating"
                                    >
                                        <div class="star-list">






                                            <div *ngFor="let rating of maxRatingCount">
                                                <div [ngSwitch]="book.audioBook.rating.average >= rating">
                                                    <div *ngSwitchCase="true">
                                                        <!-- full star -->
                                                        <svg
                                                            id="fullStar"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            :xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            x="0px"
                                                            y="0px"
                                                            width="10px"
                                                            height="10px"
                                                            viewBox="0 0 15 15"
                                                            enable-background="new 0 0 15 15"
                                                            :xml:space="preserve"
                                                        >
                                                            <path
                                                                fill="#0085CB"
                                                                stroke="#0085CB"
                                                                stroke-miterlimit="10"
                                                                d="M7.478,1.038L9.8,4.993l4.3,1.079l-2.882,3.506l0.344,4.585
                              L7.478,12.41l-4.041,1.753l0.344-4.585L0.9,6.072l4.3-1.079L7.478,1.038z"
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                    <div *ngSwitchCase="false">
                                                        <div [ngSwitch]="book.audioBook.rating.average > (rating-1)">
                                                            <div *ngSwitchCase="true">






                                                                <!-- under half -->
                                                                <div *ngIf="( book.audioBook.rating.average - (book.audioBook.rating.average | Trunc)) < 0.5">
                                                                    <svg
                                                                        id="underHlfStart"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        :xmlns:xlink="http://www.w3.org/1999/xlink"
                                                                        x="0px"
                                                                        y="0px"
                                                                        width="10px"
                                                                        height="10px"
                                                                        viewBox="0 0 15 15"
                                                                        enable-background="new 0 0 15 15"
                                                                        :xml:space="preserve"
                                                                    >
                                                                        <path
                                                                            fill="#0085CB"
                                                                            d="M5.583,13.75l-2.662,1.192l0.39-5.195L0.047,5.775l5.492-1.371L5.583,13.75z"
                                                                        ></path>
                                                                        <path
                                                                            fill="none"
                                                                            stroke="#0085CB"
                                                                            stroke-miterlimit="10"
                                                                            d="M7.478,1.038L9.8,4.993l4.3,1.079l-2.882,3.506l0.344,4.585
                                  L7.478,12.41l-4.041,1.753l0.344-4.585L0.9,6.072l4.3-1.079L7.478,1.038z"
                                                                        ></path>
                                                                    </svg>
                                                                </div>






                                                                <!-- half star -->
                                                                <div *ngIf="( book.audioBook.rating.average - (book.audioBook.rating.average | Trunc)) == 0.5">
                                                                    <svg
                                                                        id="halfStar"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        :xmlns:xlink="http://www.w3.org/1999/xlink"
                                                                        x="0px"
                                                                        y="0px"
                                                                        width="10px"
                                                                        height="10px"
                                                                        viewBox="0 0 15 15"
                                                                        enable-background="new 0 0 15 15"
                                                                        :xml:space="preserve"
                                                                    >
                                                                        <path
                                                                            fill="#0085CB"
                                                                            d="M7.5,0.07v12.886l-4.579,1.986l0.39-5.195L0.047,5.775l4.872-1.222L7.5,0.07z"
                                                                        ></path>
                                                                        <path
                                                                            fill="none"
                                                                            stroke="#0085CB"
                                                                            stroke-miterlimit="10"
                                                                            d="M7.478,1.038L9.8,4.993l4.3,1.079l-2.882,3.506l0.344,4.585
                                    L7.478,12.41l-4.041,1.753l0.344-4.585L0.9,6.072l4.3-1.079L7.478,1.038z"
                                                                        ></path>
                                                                    </svg>
                                                                </div>






                                                                <!-- upper half -->
                                                                <div *ngIf="( book.audioBook.rating.average - (book.audioBook.rating.average | Trunc)) > 0.5">
                                                                    <svg
                                                                        id="upperHalfStar"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        :xmlns:xlink="http://www.w3.org/1999/xlink"
                                                                        x="0px"
                                                                        y="0px"
                                                                        width="10px"
                                                                        height="10px"
                                                                        viewBox="0 0 15 15"
                                                                        enable-background="new 0 0 15 15"
                                                                        :xml:space="preserve"
                                                                    >
                                                                        <path
                                                                            fill="#0085CB"
                                                                            d="M7.467,0.1l2.285,3.895L9.553,13.82l-2.086-0.896L2.915,14.9l0.388-5.17L0.057,5.777l4.843-1.217L7.467,0.1z
                                    "
                                                                        ></path>
                                                                        <path
                                                                            fill="none"
                                                                            stroke="#0085CB"
                                                                            stroke-miterlimit="10"
                                                                            d="M7.478,1.038L9.8,4.993l4.3,1.079l-2.882,3.506l0.344,4.585
                                    L7.478,12.41l-4.041,1.753l0.344-4.585L0.9,6.072l4.3-1.079L7.478,1.038z"
                                                                        ></path>
                                                                    </svg>
                                                                </div>
                                                            </div>






                                                            <!-- empty start -->
                                                            <div *ngSwitchCase="false">
                                                                <svg
                                                                    id="Layer_1"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    :xmlns:xlink="http://www.w3.org/1999/xlink"
                                                                    x="0px"
                                                                    y="0px"
                                                                    width="10px"
                                                                    height="10px"
                                                                    viewBox="0 0 15 15"
                                                                    enable-background="new 0 0 15 15"
                                                                    :xml:space="preserve"
                                                                >
                                                                    <path
                                                                        fill="none"
                                                                        stroke="#0085CB"
                                                                        stroke-miterlimit="10"
                                                                        d="M7.478,1.038L9.8,4.993l4.3,1.079l-2.882,3.506l0.344,4.585
                              L7.478,12.41l-4.041,1.753l0.344-4.585L0.9,6.072l4.3-1.079L7.478,1.038z"
                                                                    ></path>
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="cur-categories-img">
                                <img
                                    [lazySrc]="_environment.imageUrl + '/content/books/' + book.audioBook.audioBookId + '/pic.jpg?t=' + book.audioBook.recordVersion + '&w=250&h=250&mode=stretch'"
                                    lazySrcVisible="visible"
                                    loading="lazy"
                                    src="assets/img/placeholder.png"
                                    class="wrapper-img-slider"
                                >
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </section>
</navaar-container-scroll>

<ng-template #menu_item_icon>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="20"
        viewBox="0 0 20 20"
    >
        <g
            fill="#fff"
            fill-rule="nonzero"
            transform="translate(1 11)"
        >
            <circle
                cx="2.5"
                cy="-8"
                r="2"
            ></circle>
            <circle
                cx="2.5"
                cy="0"
                r="2"
            ></circle>
            <circle
                cx="2.5"
                cy="8"
                r="2"
            ></circle>
        </g>



    </svg>
</ng-template>
<ng-template #podcast_icon>
    <svg
        class="genre-icon"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        :xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="26px"
        height="26px"
        viewBox="0 0 26 26"
        enable-background="new 0 0 26 26"
        :xml:space="preserve"
    >
        <g>
            <g>
                <g>
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        fill="#F8AF00"
                        d="M6.104,8.272c0-3.809,3.088-6.896,6.896-6.896
c3.809,0,6.896,3.088,6.896,6.896l0,3.827l1.719,0c0,0,1.04,0.042,1.04,1.034c0,0.272-0.107,0.533-0.297,0.725l-2.462,2.462l0,0
c0.011,3.821-3.073,6.924-6.896,6.924c-3.809,0-6.896-3.088-6.896-6.896l0-0.028l-2.462-2.462
c-0.19-0.193-0.297-0.454-0.297-0.725c0-0.992,1.04-1.034,1.04-1.034l1.719,0L6.104,8.272L6.104,8.272z M9.552,16.348
c0,1.904,1.544,3.448,3.448,3.448c1.904,0,3.448-1.544,3.448-3.448l0-8.076c0-1.904-1.544-3.448-3.448-3.448
c-1.904,0-3.448,1.544-3.448,3.448L9.552,16.348z"
                    ></path>
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        fill="#F8AF00"
                        d="M9.861,24.624c-0.095,0-0.172-0.077-0.172-0.172
c0-0.045,0.018-0.088,0.049-0.121L13,21.073l3.261,3.258c0.031,0.033,0.049,0.076,0.049,0.121c0,0.095-0.077,0.172-0.172,0.172
H9.861z"
                    ></path>
                </g>
            </g>
        </g>
    </svg>
</ng-template>
<ng-template #series_icon>
    <svg
        class="genre-icon"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        :xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="26px"
        height="26px"
        viewBox="0 0 26 26"
        enable-background="new 0 0 26 26"
        :xml:space="preserve"
    >
        <g>
            <g>
                <g>
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        fill="#E3002C"
                        d="M20.418,11.79l4.583,4.589c0.045,0.046,0.107,0.072,0.171,0.072
c0.133,0,0.241-0.108,0.241-0.241l0.001-9.172c0-0.133-0.108-0.241-0.241-0.241c-0.063,0-0.124,0.025-0.17,0.069l-4.584,4.585
c-0.045,0.045-0.071,0.107-0.071,0.171C20.348,11.684,20.373,11.745,20.418,11.79z"
                    ></path>
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        fill="#E3002C"
                        d="M15.759,18.517c3.809,0,6.896-3.088,6.896-6.897
c0-3.809-3.088-6.896-6.896-6.896c-2.667,0-5.609,0-8.276,0c-3.809,0-6.896,3.088-6.896,6.896c0,3.809,3.088,6.897,6.896,6.897
h0.744l2.462,2.462c0.193,0.19,0.454,0.297,0.725,0.297c0.992,0,1.034-1.04,1.034-1.04l0-1.719H15.759L15.759,18.517z
M7.483,15.069c-1.904,0-3.448-1.544-3.448-3.448c0-1.904,1.544-3.448,3.448-3.448l8.276,0c1.904,0,3.448,1.544,3.448,3.448
c0,1.904-1.544,3.448-3.448,3.448L7.483,15.069z"
                    ></path>
                </g>
            </g>
        </g>
    </svg>
</ng-template>
<ng-template #capsul_icon>
    <svg
        class="genre-icon"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        :xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="26px"
        height="26px"
        viewBox="0 0 26 26"
        enable-background="new 0 0 26 26"
        :xml:space="preserve"
    >
        <g>
            <g>
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    fill="#34AE7A"
                    d="M17.827,18.517c3.809,0,6.896-3.088,6.896-6.897
                          c0-3.809-3.088-6.896-6.896-6.896l-9.627,0c-0.009,0-0.019,0-0.028,0c-3.809,0-6.896,3.088-6.896,6.896
                          c0,3.809,3.088,6.897,6.896,6.897h1.296l2.462,2.462c0.193,0.19,0.454,0.297,0.725,0.297c0.992,0,1.034-1.04,1.034-1.04l0-1.719
                          H17.827L17.827,18.517z M8.173,15.069c-1.904,0-3.448-1.544-3.448-3.448c0-1.904,1.544-3.448,3.448-3.448l9.655,0
                          c1.904,0,3.448,1.544,3.448,3.448c0,1.904-1.544,3.448-3.448,3.448L8.173,15.069z"
                ></path>
            </g>
        </g>
    </svg>
</ng-template>
<ng-template #audiobook_icon>
    <svg
        class="genre-icon"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        :xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="26px"
        height="26px"
        viewBox="0 0 26 26"
        enable-background="new 0 0 26 26"
        :xml:space="preserve"
    >
        <g>
            <g>
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    fill="#597DBD"
                    d="M13.008,24.624c-3.818,0-6.902-3.075-6.896-6.896
c0.01-6.255-0.023-8.371-0.015-14.626c0.001-0.948,0.776-1.724,1.724-1.724c0.948,0,1.724,0.776,1.724,1.724
c0,1.904,1.544,3.448,3.448,3.448c1.904,0,3.448-1.544,3.448-3.448c0-1.081,1.035-1.96,2.154-1.67
c0.742,0.192,1.295,0.869,1.295,1.67c0,8.235,0.004,7.613,0.015,14.626C19.91,21.549,16.826,24.624,13.008,24.624L13.008,24.624z
M16.456,17.728c0.017-4.259-0.014-4.387-0.014-8.647c-1.014,0.584-2.191,0.917-3.448,0.917c-1.257,0-2.434-0.333-3.448-0.917
c0,4.262,0.015,4.385,0.015,8.647c0,1.904,1.544,3.448,3.448,3.448C14.912,21.176,16.449,19.632,16.456,17.728z"
                ></path>
            </g>
        </g>
    </svg>
</ng-template>
<ng-template #option_menu let-book>
    <div
        class="option-container"
        (click)="showOptionMenu($event, optionmenu)"
    >
        <ng-container *ngTemplateOutlet="menu_item_icon"></ng-container>
    </div>
    <div navaarClickOutside (clickOutside)="closeOptionMenu($event, optionmenu)" (click)="openOptionDialog(book.productId, $event, book.audioBook.title); optionmenu.classList.remove('active')" class="dropdown_option_menu" #optionmenu>
        <span>افزودن به کتابخانه</span>
    </div>
</ng-template>
